import LayoutComponent from "src/components/user/layout-component";
import ProfileParentConatiner from "src/containers/user/profile-parent-container/profile-parent-conatiner";

function ParentProfilePage() {
  return (
    <LayoutComponent showLogo={true}>
      <ProfileParentConatiner />
    </LayoutComponent>
  );
}

export default ParentProfilePage;
